module.exports = __webpack_public_path__ + "img/payamak-land.e5ad632a.webp";